import { render, staticRenderFns } from "./formasLlegada.vue?vue&type=template&id=06eb2a92"
import script from "./formasLlegada.vue?vue&type=script&lang=js"
export * from "./formasLlegada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports